export const BOARD_LIMIT = 20;
export const POSTS_PER_BOARD_LIMIT = 1000;
